import { call } from 'redux-saga/effects';
import { authToken } from 'services/auth/selectors';

// Must use axios.request method because others require url to be first arg,
// This function only supports a single options arg
export default function apiAuthCall(state, apiFunction, options) {
    let opts = {};
    const token = authToken(state);

    if (token) {
        opts = {
            headers: Object.assign({}, options.headers || {}, {
                Authorization: `Bearer ${token}`
            })
        };
    }

    return call(
        apiFunction,
        Object.assign({}, options, opts)
    );
}



// WEBPACK FOOTER //
// ./src/helpers/apiAuthCall.js